import { z } from "zod";
import { ZONE_NAME, DESCRIPTION } from "./consts";

export const schema = z.object({
  [ZONE_NAME]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type AddZoneFormValues = z.infer<typeof schema>;
